/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Gps_Provider_VnetgpsInputs */

const vi_vehicle_gps_provider_vnetgps = /** @type {(inputs: Vehicle_Gps_Provider_VnetgpsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VnetGPS`)
};

/**

* @param {Vehicle_Gps_Provider_VnetgpsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const vehicle_gps_provider_vnetgps = /** @type {((inputs?: Vehicle_Gps_Provider_VnetgpsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Gps_Provider_VnetgpsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_vehicle_gps_provider_vnetgps(inputs)
});